import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface AuthSidebarState {
    isAuthSidebarOpen: boolean;
    preventClose: boolean;
}
interface AuthSidebarStateStore extends AuthSidebarState {
    openAuthSidebar: () => void;
    closeAuthSidebar: () => void;
    setPreventClose: (preventClose: boolean) => void;
}

const initialState: AuthSidebarState = {
    isAuthSidebarOpen: false,
    preventClose: false,
};

export const useAuthSidebar = create<AuthSidebarStateStore>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                openAuthSidebar: () => set({ isAuthSidebarOpen: true }),
                closeAuthSidebar: () => set({ isAuthSidebarOpen: false }),
                setPreventClose: (preventClose) => set({ preventClose }),
            }),
            { name: 'auth-sidebar-storage' },
        ),
    ),
);
